export const mapFiltersForQuery = (
  filters: Record<string, string | boolean | number | null | undefined>
) => {
  // const filtersCopy = structuredClone(filters);
  const filtersCopy = { ...filters };

  // if the not_started filter is true, we need to remove the percent_complete filters
  // or the API returns nothing :(
  if (filtersCopy.not_started === true) {
    filtersCopy['percent_complete[lte]'] = null;
    filtersCopy['percent_complete[gte]'] = null;
  } else {
    // remove the not_started filter if it's false as it does nothing
    delete filtersCopy.not_started;
  }
  // if percent_complete is 0 or 100, remove it
  if (filtersCopy['percent_complete[lte]'] === 100) {
    delete filtersCopy['percent_complete[lte]'];
  }
  if (filtersCopy['percent_complete[gte]'] === 0) {
    delete filtersCopy['percent_complete[gte]'];
  }

  Object.keys(filtersCopy).forEach((key) => {
    if (
      filtersCopy[key] === '' ||
      filtersCopy[key] === undefined ||
      filtersCopy[key] === null
    ) {
      delete filtersCopy[key];
    }
  });

  return filtersCopy;
};
